import { mapActions } from "vuex"
import { isUrl } from "bits/url"
import { trackEvent } from "bits/analytics"
import { $ } from "bits/jquery"

export default {
  data() {
    return {
      dropToPostSubscribed: false,
      $_dropToPostMixin_callback: null
    }
  },
  methods: {
    ...mapActions('post', ['createPost']),
    $_dropToPostMixin_processDrop(e) {
      e.preventDefault()
      const wishListElement = document.getElementById("wish-list")
      let left = 0, top = 0
      if (wishListElement) {
        left = Math.max((e.originalEvent.pageX - wishListElement.getBoundingClientRect().left), 0)
        top = Math.max((e.originalEvent.pageY - wishListElement.getBoundingClientRect().top), 0)
      } else {
        left = Math.max((e.originalEvent.pageX), 0)
        top = Math.max((e.originalEvent.pageY), 0)
      }
      let offset = 0

      if (e.originalEvent.dataTransfer) {
        // try files
        let files = e.originalEvent.dataTransfer.files
        if (files && files.length > 0) {
          for (var i = 0; i < files.length; i++) {
            let file = files[i]
            this.$_dropToPostMixin_processFileDrop(file, top + offset, left + offset)
            offset += 8
          }
        } else {
          // a non-file has been likely dragged
          // try link
          let link = e.originalEvent.dataTransfer.getData("text/uri-list")
          if (link) {
            this.$_dropToPostMixin_processLinkDrop(link, top, left)
          } else {
            let text = e.originalEvent.dataTransfer.getData('text/plain')
            if (text) {
              if (isUrl(text)) {
                this.$_dropToPostMixin_processLinkDrop(text, top, left)
              } else {
                this.$_dropToPostMixin_processTextDrop(text, top, left)
              }
            }
          }
        }
      }

      return false
    },

    $_dropToPostMixin_processFileDrop(file, top, left) {
      this.$_dropToPostMixin_track("File")
      const newPost = {
        attributes: {
          file: file,
          top: top,
          left: left
        }
      }
      this.$_dropToPostMixin_callback ? this.$_dropToPostMixin_callback(newPost) : this.createPost(newPost)
    },

    $_dropToPostMixin_processLinkDrop(link, top, left) {
      this.$_dropToPostMixin_track("Link")
      const newPost = {
        attributes: {
          attachment: link,
          top: top,
          left: left
        }
      }
      this.$_dropToPostMixin_callback ? this.$_dropToPostMixin_callback(newPost) : this.createPost(newPost)
    },

    $_dropToPostMixin_processTextDrop(text, top, left) {
      this.$_dropToPostMixin_track("Text")
      const newPost = {
        attributes: {
          body: text,
          top: top,
          left: left
        }
      }
      this.$_dropToPostMixin_callback ? this.$_dropToPostMixin_callback(newPost) : this.createPost(newPost)
    },

    $_dropToPostMixin_track(type) {
      trackEvent("Posts", "add", `${type} drop`)
    },

    enableDropToPost(wallContainerEl, callback) {
      const DRAGOVER_CLASS = "is-dragover"
      const $element = $(wallContainerEl || "#wall-container")
      if (this.dropToPostSubscribed) return
      this.$_dropToPostMixin_callback = callback
      $element.on("dragover.droptopost", (e) => {
        $element.addClass(DRAGOVER_CLASS)
        return false
      })
      $element.on("dragleave.droptopost dragend.droptopost", (e) => {
        $element.removeClass(DRAGOVER_CLASS)
        return false
      })
      $element.on("drop.droptopost", (e) => {
        $element.removeClass(DRAGOVER_CLASS)
        this.$_dropToPostMixin_processDrop(e)
      })
      this.dropToPostSubscribed = true
    },

    disableDropToPost(wallContainerEl) {
      const $element = $(wallContainerEl || "#wall-container")
      this.$_dropToPostMixin_callback = null
      if (!this.dropToPostSubscribed) return
      $element.off(".droptopost")
      this.dropToPostSubscribed = false
    },
  },
}
